import { Link } from 'react-router-dom'
import { Card } from '../components/Card'
import { ProgressBar } from '../components/ProgressBar'
import { StatusMarker } from '../components/StatusMarker'
import { EmptyState } from '../components/EmptyState'
import { PageContainer } from '../components/PageContainer'
import { progressRepository } from '../../persistence/progressRepository'
import { buildLearningPathView, type LessonView } from '../viewModels/learningPath'
import styles from './JourneyScreen.module.css'

/** Journey: the whole path as a compact, status-marked sequence. */
export function JourneyScreen() {
  const path = buildLearningPathView(progressRepository.load())

  return (
    <PageContainer title="Journey" lede={path.name}>
      <Card>
        <ProgressBar value={path.completedCount} max={path.total} label={`${path.name} progress`} />
      </Card>

      {path.lessons.length === 0 ? (
        <EmptyState
          title="No lessons yet"
          description="The curriculum for this path has not been generated yet."
        />
      ) : (
        <ol className={styles.list}>
          {path.lessons.map((lesson) => (
            <li key={lesson.id} className={styles.item}>
              <JourneyRow lesson={lesson} />
            </li>
          ))}
        </ol>
      )}
    </PageContainer>
  )
}

function JourneyRow({ lesson }: { lesson: LessonView }) {
  const reachable = lesson.status !== 'upcoming'
  const node = (
    <div className={`${styles.node} ${styles[`node-${lesson.status}`]}`} aria-hidden="true">
      {lesson.status === 'completed' ? '✓' : lesson.order}
    </div>
  )

  const body = (
    <div className={styles.body}>
      <span className={styles.itemTitle}>{lesson.title}</span>
      <span className={styles.itemSummary}>{lesson.summary}</span>
    </div>
  )

  return (
    <div className={styles.row}>
      {node}
      {reachable ? (
        <Link to={`/lesson/${lesson.id}`} className={styles.link}>
          {body}
        </Link>
      ) : (
        <div className={styles.link}>{body}</div>
      )}
      <StatusMarker status={lesson.status} />
    </div>
  )
}
